export enum AnswerTypeEnum {
    Text,
    Date,
    Time,
    DateTime
}